import { makeStyles } from 'e100-react-components';

interface StyleProps {
  hasIcon: boolean;
}

export const useStyles = makeStyles(({ spacing }) => ({
  labelPlacementStart: ({ hasIcon }: StyleProps) => ({
    width: '100%',
    justifyContent: 'space-between',
    marginLeft: hasIcon ? spacing(0.75) : 0
  }),
  iconContainer: {
    width: spacing(5)
  },
  checkboxContainer: {
    width: '100%'
  },
  checkboxRoot: ({ hasIcon }: StyleProps) => ({
    marginRight: hasIcon ? spacing(-0.3) : spacing(-1.3) 
  })
}));
